export const FactoryBackgroundTypes = {
  GRADIENT: 'gradient',
  IMAGE: 'image',
};

export const SiteTypes = {
  KANBAN: 'kanban',
};

export const ActionTypes = {
  CREATE_DEVICE: 'createDevice',
  MOVE_DEVICE: 'moveDevice',
  COMMENT_DEVICE: 'commentDevice',
};
